import React from 'react';
import logo from '../assets/images/Logo_Probuild.png';

const Preloader = () => {
  return (
    <div className="fixed inset-0 bg-white z-[100] flex items-center justify-center">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000' fill-opacity='0.1'%3E%3Crect width='1' height='1'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          backgroundSize: '60px 60px'
        }}></div>
      </div>

      {/* Logo and Loading Animation */}
      <div className="relative z-10 text-center">
        {/* Logo */}
        <div className="mb-8 opacity-0 animate-fade-in" style={{ animationDelay: '0.2s', animationFillMode: 'forwards' }}>
          <img 
            src={logo} 
            alt="PROBUILD MARKET" 
            className="h-40 w-auto mx-auto"
          />
        </div>

        {/* Loading Animation */}
        <div className="flex items-center justify-center space-x-2 opacity-0 animate-fade-in" style={{ animationDelay: '0.8s', animationFillMode: 'forwards' }}>
          <div className="flex space-x-1">
            {[1, 2, 3, 4, 5].map((i) => (
              <div
                key={i}
                className="w-2 h-8 bg-gray-800 rounded-sm animate-pulse"
                style={{
                  animationDelay: `${i * 0.1}s`,
                  animationDuration: '1.2s'
                }}
              ></div>
            ))}
          </div>
        </div>

        

        {/* Progress Indicator */}
        <div className="mt-8 w-48 mx-auto opacity-0 animate-fade-in" style={{ animationDelay: '1.6s', animationFillMode: 'forwards' }}>
          <div className="h-px bg-gray-200 rounded-full overflow-hidden">
            <div className="h-full bg-gray-800 rounded-full animate-progress"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preloader;